import set from 'lodash/set';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import * as actionTypes from '../constants/actionTypes';
import initialState from './initialState';

const modalsReducer = (state = initialState.modals, action: any) => {
  const stateClone = cloneDeep(state);

  switch (action.type) {
    case actionTypes.SHOW_ERROR_MODAL:
      set(stateClone, 'error.open', true);
      set(stateClone, 'error.title', 'Invoice Error');
      set(stateClone, 'error.message', get(action, 'payload.message', ''));
      return stateClone;
    default:
      return state;
  }
};

export default modalsReducer;
